import { Injectable } from '@angular/core';
import { Feature } from './feature';

@Injectable({
  providedIn: 'root'
})
export class VeiligOnlineProductsFeature extends Feature {}
